"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _GoodSubTypes$EMAIL_T;

var _default = (_GoodSubTypes$EMAIL_T = {}, (0, _defineProperty2.default)(_GoodSubTypes$EMAIL_T, _GoodSubTypes.default.EMAIL_TEMPLATES, 'email'), (0, _defineProperty2.default)(_GoodSubTypes$EMAIL_T, _GoodSubTypes.default.LANDING_PAGES, 'landing_page'), (0, _defineProperty2.default)(_GoodSubTypes$EMAIL_T, _GoodSubTypes.default.SITE_PAGES, 'site_page'), _GoodSubTypes$EMAIL_T);

exports.default = _default;
module.exports = exports.default;